export default __webpack_public_path__ + "static/media/offer_banner.0ff661a7.svg";